<div class="workflow-designer" [class.is-resizing-properties]="isResizingProperties()">
  <main class="workflow-designer-content">
    <app-workflow-toolbar
      [name]="workflowName()"
      [description]="workflowDescription()"
      [nodeCount]="nodeCount()"
      [canSave]="!hasValidationErrors()"
      [hasUnsavedChanges]="unsavedChanges()"
      [orientation]="orientation()"
      (nameChange)="onNameChange($event)"
      (descriptionChange)="onDescriptionChange($event)"
      (createNew)="onCreateNew()"
      (openExisting)="onOpenSelector()"
      (orientationChange)="onOrientationChange($event)"
      (save)="onSave()"
    />

    <app-workflow-validation-panel
      [result]="validation()"
      (selectNode)="onSelectNode($event)"
    />

    <div
      #workflowBody
      class="workflow-body"
      [style.--properties-width]="propertiesWidth() + 'px'"
    >
    <aside class="workflow-palette">
      <app-workflow-node-palette (addNode)="onAddNode($event)" />
    </aside>

    <section class="workflow-canvas">
      <app-workflow-canvas
        [nodes]="nodes()"
        [positions]="positions()"
        [selectedNodeId]="selectedNodeId()"
        (selectNode)="onSelectNode($event)"
        (moveNode)="onMoveNode($event)"
        (connectNodes)="onConnectNodes($event)"
        (deleteEdge)="onDeleteEdge($event)"
        (deleteNode)="onDeleteNode($event)"
        (measureNodes)="onMeasureNodes($event)"
        (measureCanvas)="onMeasureCanvas($event)"
      />
    </section>

    <aside class="workflow-properties">
      <div
        class="properties-resizer"
        role="separator"
        tabindex="0"
        aria-orientation="vertical"
        aria-label="Resize details panel"
        [attr.aria-valuenow]="propertiesWidth()"
        [attr.aria-valuemin]="propertiesMinWidth"
        title="Drag to resize. Double-click to reset."
        (pointerdown)="onPropertiesResizeStart($event)"
        (pointermove)="onPropertiesResizeMove($event)"
        (pointerup)="onPropertiesResizeEnd()"
        (pointercancel)="onPropertiesResizeEnd()"
        (dblclick)="onPropertiesResizeReset()"
        (keydown)="onPropertiesResizeKeydown($event)"
      ></div>
      <div class="workflow-properties-scroll">
        <app-workflow-node-properties
          [node]="selectedNode()"
          [allNodes]="nodes()"
          (nodeChange)="onNodeChange($event)"
          (deleteNode)="onDeleteNode($event)"
        />
      </div>
    </aside>
    </div>
  </main>

  @if (selectorOpen()) {
    <app-workflow-selector-modal
      [workflows]="workflows()"
      [loading]="loadingWorkflows()"
      [error]="workflowsError()"
      [currentWorkflowId]="currentWorkflow()?.id ?? null"
      [previewNodes]="previewNodes()"
      [previewLoading]="loadingPreview()"
      [previewError]="previewError()"
      (previewWorkflow)="onPreviewWorkflow($event)"
      (openWorkflow)="onOpenWorkflow($event)"
      (reload)="onOpenSelector()"
      (closed)="onCloseSelector()"
    />
  }

  <app-unsaved-changes-dialog
    [(visible)]="showUnsavedChangesDialog"
    [message]="unsavedChangesMessage"
    (save)="onUnsavedChangesSave()"
    (dontSave)="onUnsavedChangesDontSave()"
    (cancel)="onUnsavedChangesCancel()"
  />
</div>
